module.exports = __webpack_public_path__ + "img/holly_springs_sign.jpg";